import { render, staticRenderFns } from "./Tradle.vue?vue&type=template&id=68409ef5&scoped=true&"
import script from "./Tradle.vue?vue&type=script&lang=js&"
export * from "./Tradle.vue?vue&type=script&lang=js&"
import style0 from "./Tradle.vue?vue&type=style&index=0&id=68409ef5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68409ef5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/vagrant/interfaces/online/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContent } from 'vuetify/lib'
import { VFooter } from 'vuetify/lib'
installComponents(component, {VContent,VFooter})
